import { render, staticRenderFns } from "./VirtualCareDashboard.vue?vue&type=template&id=15673134&"
import script from "./VirtualCareDashboard.vue?vue&type=script&lang=js&"
export * from "./VirtualCareDashboard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports